import { render } from "./PostYearCarnageReport.vue?vue&type=template&id=50d43a16&scoped=true&ts=true"
import script from "./PostYearCarnageReport.vue?vue&type=script&lang=ts"
export * from "./PostYearCarnageReport.vue?vue&type=script&lang=ts"

import "./PostYearCarnageReport.vue?vue&type=style&index=0&id=50d43a16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d43a16"]])

export default __exports__